import { HTMLAttributes } from "react";
import { AutocompleteRenderOptionState } from "@mui/material/Autocomplete/Autocomplete";
import {
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const agGridGroupingSelectRenderOption =
  (
    selectedValues: string[],
    groupingOptions: Record<string, string>,
    onNoneClick: () => void,
  ) =>
  (
    props: HTMLAttributes<HTMLLIElement> & { key: any },
    option: string,
    { selected }: AutocompleteRenderOptionState,
  ) => {
    const { key, ...optionProps } = props;
    const selectedIndex = selectedValues.findIndex((val) => val === option);

    const optionComponent = (
      <ListItem key={key} {...optionProps} sx={{ p: "4px 8px !important" }}>
        <ListItemIcon sx={{ minWidth: 0 }}>
          <Checkbox size="small" checked={selected} sx={{ p: 0, pr: 1 }} />
        </ListItemIcon>

        <ListItemText sx={{ pr: 3, whiteSpace: "nowrap" }}>
          <TypographyWithTooltip
            title={groupingOptions[option as string]}
            variant="body2"
          />
        </ListItemText>

        {selected && (
          <Typography
            variant="body2"
            sx={{
              px: 1,
              py: 0.25,
              borderRadius: "50%",
              color: "primary.main",
              bgcolor: "primary.light",
            }}
          >
            {selectedIndex + 1}
          </Typography>
        )}
      </ListItem>
    );

    if (option === "opportunity_name") {
      return [
        <ListItem
          key="none"
          onClick={onNoneClick}
          sx={{ p: "4px 8px !important", cursor: "pointer" }}
        >
          <ListItemText sx={{ pr: 3, whiteSpace: "nowrap" }}>None</ListItemText>
        </ListItem>,
        optionComponent,
      ];
    }

    return optionComponent;
  };
